// Copyright (c) 2021, Elicenciamento. All rights reserved.

import React, { createContext, useContext, useState } from "react";
import ApplicationLoading from "../../components/ApplicationLoading";

const LoadingContext = createContext({
  addLoading: () => {},
  removeLoading: () => {},
});

const LoadingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const addLoading = () => {
    setOpen(true);
  };

  const removeLoading = () => {
    setOpen(false);
  };

  const value = { addLoading, removeLoading };

  return (
    <LoadingContext.Provider value={value}>
      {open && <ApplicationLoading />}
      {children}
    </LoadingContext.Provider>
  );
};

const useLoading = () => useContext(LoadingContext);

export { LoadingProvider, useLoading };
